<!--  -->
<template>
  <div class="container">
    <div class="title-bg-block">
      <div class="title-text-block">
        <div class="title">敬神功德</div>
      </div>
      <img src="../assets/donation_bg.8848100.png"
           class="title-bg"
           :style="{ height: titleBgHeight + 'px' }" />
    </div>
    <div class="content-container">
      <div class="content-title">全部功德</div>
      <div class="content-list-block">
        <div v-for="(item, index) in meritItems"
             :key="index"
             class="item-block"
             @click="toMeritInfo(item.id)">
          <div>
            <div class="item-image-block">
              <img :src="item.photo"
                   class="item-image"
                   :style="{ height: itemImageHeight + 'px' }" />
            </div>
            <div class="item-info">
              <span class="item-name">{{ item.name }}</span>
              <span class="item-img"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      titleBgHeight: 240.8,
      itemImageHeight: 159.2,
      meritItems: [],
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    async donationData() {
      try {
        const data = await this.$http.get('/tempt/api/sjte/getMerits'); // 通过this.$http调用全局挂载的axios实例发送GET请求，这里的/api/some-endpoint根据实际后端接口调整
       this.meritItems = data.result; // 如果请求成功，将返回的数据赋值给data属性用于展示
       this.$store.commit("updateMeritList", this.meritItems);
      } catch (error) {
        console.log("error")
      } finally {
        console.log("error2")
      }
    },
    toMeritInfo(id) {
      this.$router.push("/DonationDetail",id)
      localStorage.setItem("DonationDetailId", id);
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.donationData()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, // 生命周期 - 创建之前
  beforeMount() { }, // 生命周期 - 挂载之前
  beforeUpdate() { }, // 生命周期 - 更新之前
  updated() { }, // 生命周期 - 更新之后
  beforeDestroy() { }, // 生命周期 - 销毁之前
  destroyed() { }, // 生命周期 - 销毁完成
  activated() { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
.title-bg-block {
  width: 100%;
  position: relative;
  z-index: -1;
}
.title-text-block {
  position: absolute;
  bottom: 34px;
  left: 16px;
}
.title-bg-block .title {
  font-family: PingFangSC-Semibold;
  font-size: 28px;
  color: #fff;
  letter-spacing: 0;
  margin-bottom: 10px;
}
.title-bg {
  width: 100%;
  -o-object-fit: fit;
  object-fit: fit;
}
.content-container {
  background: #fff;
  border-radius: 16px 16px 0 0;
  z-index: 2;
  padding-top: 10px;
  margin-top: -6%;
  padding-left: 16px;
  padding-right: 16px;
}
.content-title {
  border-radius: 16px 16px 0 0;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #000;
  letter-spacing: 0;
  height: 54px;
  line-height: 54px;
}
.item-block {
  width: 100%;
  background: #fff;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-bottom: 16px;
}
.item-image-block,
.item-image {
  width: 100%;
  border-radius: 8px;
}
.item-info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 45px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 16px;
}
.item-name {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #000;
  letter-spacing: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.item-img {
  background-image: url(data:image/png;base64,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);
  background-repeat: no-repeat;
  background-size: cover;
  height: 14px;
  width: 14px;
  margin-left: 4px;
}
</style>